import { cls } from '@/utils/cls';
import { formatPercentage } from '@/utils/format/number';

export type WorkstreamProgressProps = {
  progress: number;
  className?: string;
};

export function WorkstreamProgress({
  progress,
  className,
}: WorkstreamProgressProps) {
  return (
    <div
      className={cls(
        'flex w-full items-baseline gap-4 text-sm text-gray-500',
        className,
      )}
    >
      <div className="shrink-0">Progress</div>

      <div className="h-2 w-full grow rounded-full bg-gray-200">
        <div
          className="h-2 rounded-full bg-primary-400 transition-[width,background-color] duration-300 ease-in-out"
          style={{ width: `${progress * 100}%` }}
        ></div>
      </div>

      <div className="shrink-0">{formatPercentage(progress)}</div>
    </div>
  );
}
